import { FormControlProps } from '@material-ui/core/FormControl';
import { ReactElement } from 'react';
import { Control, Controller, FieldErrors, FieldValues, Path } from 'react-hook-form';
import { DatePickerView, DatePickerViewsProps } from '@material-ui/pickers';
import get from 'lodash/get';
import DatePickerMUI from './DatePickerMUI';

import { generalDate } from '~/ui/constants/dateFormat';

interface IProps<TFieldValues extends FieldValues = FieldValues> {
  control: Control<TFieldValues>;
  errors: FieldErrors;
  name: string;
  minDate?: string;
  maxDate?: string;
  label?: string;
  placeholder?: string;
  disabled?: boolean;
  clearable?: boolean;
  dateFormat?: string;
  openTo?: DatePickerViewsProps['openTo'];
  size?: FormControlProps['size'];
  tabIndex?: number;
  className?: string;
  views?: DatePickerView[];
  cb?: (value: Date) => void;
}

const DatePickerComponent = <TFieldValues extends FieldValues = FieldValues>({
  control,
  errors,
  name,
  minDate,
  maxDate,
  openTo = 'year',
  label = '',
  placeholder = '',
  disabled = false,
  dateFormat = generalDate,
  size = 'small',
  views = ['year', 'month', 'date'],
  tabIndex,
  clearable,
  className,
  cb,
}: IProps<TFieldValues>): ReactElement => {
  const error = get(errors, `${name}.message`, '');

  return (
    <Controller
      control={control}
      name={name as Path<TFieldValues>}
      render={({ field: { value, onChange } }) => (
        <DatePickerMUI
          size={size}
          label={label}
          error={error as string}
          openTo={openTo}
          views={views}
          minDate={minDate}
          maxDate={maxDate}
          dateFormat={dateFormat}
          value={value as Date | string}
          onChange={onChange}
          disabled={disabled}
          placeholder={placeholder}
          clearable={clearable}
          className={className}
          tabIndex={tabIndex}
          cb={cb}
        />
      )}
    />
  );
};

export default DatePickerComponent;
